import Vue from "vue";
export default function setReactive(object, key, value) {
    Vue.set(object, key, value);
}
